module.exports = __webpack_public_path__ + "img/Future-expenditure.0db8ef52.svg";